import { styled } from "@mui/material/styles";
import {
  Box,
  Typography,
  Button,
  FormControl,
  MenuItem,
  Input,
  TextField,
  InputAdornment,
  Select,
} from "@mui/material";

export const StyledBox = styled(Box)({
  fontFamily: '"Bai Jamjuree", sans-serif',
  borderRadius: "0.3rem",
  padding: "1.5rem",
  // backgroundColor: "#333333",
  backgroundColor: 'rgb(17, 17 ,17)',
  // boxShadow: "0px 0px 11px 0px #1d2838",
  // border: "1px solid #1d2838",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  marginTop: "2rem",
  alignItems: "center",
  justifyContent: "space-between",
});

export const StyledTypography = styled(Typography)({
  fontFamily: '"Bai Jamjuree", sans-serif',
  color: "#ffffff",
});

export const StyledTypographyBlack = styled(Typography)({
  fontFamily: '"Bai Jamjuree", sans-serif',
  color: "#000",
});


export const StyledFormControl = styled(FormControl)({
  fontFamily: '"Bai Jamjuree", sans-serif',
});

export const StyledButton = styled(Button)({
  fontFamily: '"Bai Jamjuree", sans-serif',
  borderColor: "#ff851b",
  backgroundColor: "#e8442d",
  color: "white",
  fontWeight: "900",
  "&:hover": {
    borderColor: "#ffae68",
    backgroundColor: "#eb5a46",
  },
  "&:disabled": {
    backgroundColor: "#d3d3d3",
  },
});

export const StyledMenuItem = styled(MenuItem)({
  fontWeight: "700",
  fontFamily: '"Bai Jamjuree", sans-serif',
});

export const StyledInput = styled(Input)({
  marginTop: "0.5rem",
  border: "1px solid #ff851b",
  borderRadius: "4px",
  padding: "10px",
  "&:focus": {
    borderColor: "#ff851b",
    boxShadow: "0 0 0 2px rgba(255, 133, 27, 0.3)",
  },
});

export const StyledTextField = styled(TextField)({
  backgroundColor: "white",
  borderRadius: "0.3rem",
  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ff851b",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ff851b",
  },
});

export const StyledSelect = styled(Select)({
  backgroundColor: "white",
  borderRadius: "0.3rem",
  fontFamily: '"Bai Jamjuree", sans-serif',
  fontWeight: "700",
});
